import React from 'react'
import ListingPageWithRoutes from 'containers/ListingPage/listingRouter'
import { getMessage } from 'lib/translator'
import WhitelistDomainFilters from './Filters'
import WhitelistDomainHeaderActions from './WhitelistDomainHeaderActions'
import { tableProperties } from './tableProperties'
import './style.css'

const API_URL = '/lms/content/domains'

const WHITELIST_PK = 'domain#whitelisting'

const DEFAULT_PARAMS = {
  contentType: 'domain',
  key: 'whitelisting',
  limit: 20,
}

const emptyState = {
  actions: WhitelistDomainHeaderActions,
}

export default function WhitelistDomain(props) {
  return (
    <ListingPageWithRoutes
      title={getMessage('whitelistDomain.title')}
      menu={props.menu}
      className="whitelist-domain-listingpage"
      api={{
        url: API_URL,
        params: DEFAULT_PARAMS,
        updateUrl: '/lms/content',
        transform: (res) => {
          const data = res.data ?? res
          let items = Array.isArray(data)
            ? data
            : data?.items ?? data?.domains ?? []
          if (!Array.isArray(items) && data && typeof data === 'object') {
            items = [data]
          }
          if (!Array.isArray(items)) {
            return []
          }
          return items.map((item) => ({
            ...item,
            pk: item.pk ?? WHITELIST_PK,
            sk: item.sk ?? item.id,
            isDisabled: item.isDisabled ?? item.enabled === false,
          }))
        },
      }}
      headerActions={WhitelistDomainHeaderActions}
      emptyState={emptyState}
      tableProperties={tableProperties()}
      form={{}}
      primaryKey="sk"
      filters={{
        component: WhitelistDomainFilters,
        forceShow: true,
        transformSubmit: (values) => {
          const params = { ...DEFAULT_PARAMS, ...values }
          if (params.domain !== undefined && params.domain === '') {
            delete params.domain
          }
          if (params.enabled === '' || params.enabled === undefined) {
            delete params.enabled
            delete params.status
          } else {
            params.status = params.enabled === 'true' ? 'active' : 'inactive'
            delete params.enabled
          }
          return params
        },
      }}
    />
  )
}
